import { TypedOrders } from './orders.query';
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { IQueryParams } from 'queries';
import helpers from 'helpers/index';
import queryClient from 'queries';

/**
 *   Interface/model file auto generate for Flight_radar
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */
export interface TypedFlight_radar {
  /** ID bản ghi. Ví dụ: `'1'`. */
  id?: string;

  /** Mã chuyến bay. Ví dụ: `'VU1270'`. */
  flight?: string;

  /** Ngày bay, định dạng `YYYY-MM-DD`. Ví dụ: `'2026-09-21'`. */
  departure_date?: string;

  /** Nơi khởi hành. Ví dụ: `'CAM RANH'`. */
  flight_from?: string;

  /** Giờ hạ cánh dự kiến, UTC+7. Ví dụ: `'2026-09-21T11:50:00+07:00'`. */
  estimated_landing_time?: string;

  /** Giờ hạ cánh theo lịch, UTC+7. Ví dụ: `'2026-09-21T11:50:00+07:00'`. */
  scheduled_landing_time?: string;

  /** Nhà ga. Ví dụ: `'T1'`. */
  terminal?: string;

  /** Trạng thái chuyến bay do dịch vụ theo dõi chuyến bay trả về. */
  status?: string;

  /** Thời điểm tạo, Unix timestamp mili-giây dạng chuỗi. Ví dụ: `'1789966200000'`. */
  createdAt?: string;

  /** Thời điểm cập nhật, Unix timestamp mili-giây dạng chuỗi. Ví dụ: `'1789966200000'`. */
  updatedAt?: string;

  /** Các đơn hàng đang liên kết với chuyến bay. */
  flight_radar_to_order?: {
    /** ID bản ghi liên kết. Ví dụ: `'10'`. */
    id?: string;

    /** ID đơn hàng. Ví dụ: `'125'`. */
    order_id?: string;

    /** ID chuyến bay. Ví dụ: `'1'`. */
    flight_radar_id?: string;

    /** Thời điểm tạo liên kết, Unix timestamp mili-giây dạng chuỗi. Ví dụ: `'1789966200000'`. */
    createdAt?: string;

    /** Thông tin chuyến bay của liên kết. */
    flight_radar?: TypedFlight_radar;

    /** Thông tin đơn hàng của liên kết. */
    orders?: TypedOrders;
  }[]

}



type IQuery = TypedFlight_radar & IQueryParams;

/*
 * List of all app
 */
export function useGetFlightRadars(object: IQuery) {
  const EndURL = helpers.buildEndUrl(object);
  return useQuery({
    queryKey: ['flight_radar/fetch_entity_list', object],
    queryFn: () =>
      axios.get<TypedFlight_radar[]>(`/flight_radar${EndURL}`).then((response) => {
        let { data, headers } = response;
        return {
          body: data,
          totalItems: Number(headers['x-total-count'] || 0),
        };
      }),
    enabled: true,
  });
}

export function useGetInfiniteFlightRadars(object: IQuery) {
  const limit = object.limit || 20;
  return useInfiniteQuery({
    queryKey: ['flight_radar/fetch_entity_list', 'infinite', object],
    initialPageParam: 1,
    queryFn: async ({ pageParam, signal }) => {
      const url = helpers.buildEndUrl({ ...object, limit, page: pageParam });
      const { data, headers } = await axios.get<TypedFlight_radar[]>(`/flight_radar${url}`, { signal });
      return {
        body: data,
        totalItems: headers['x-total-count'] != null ? Number(headers['x-total-count']) : undefined,
      };
    },
    getNextPageParam: (lastPage, pages, lastPageParam) => {
      const loaded = pages.reduce((count, page) => count + page.body.length, 0);
      if (lastPage.body.length < limit || (lastPage.totalItems != null && loaded >= lastPage.totalItems)) return undefined;
      return lastPageParam + 1;
    },
  });
}


/** Thêm dữ liệu chuyến bay để theo dõi ... */
export function useAddFlightRadar() {
  return useMutation({
    mutationKey: ['flight_radar/add'],
    mutationFn: (flightData: {
      flight_number: string;
      date_to_watch: string;
      order_code: string;
    }) => axios.post<any>(`/flight_radar`, flightData).then(response => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flight_radar/fetch_entity_list'] });
      queryClient.invalidateQueries({ queryKey: ['flight_radar/fetch_entity'] });
      queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
    }

  });
}


/** Thêm dữ liệu chuyến bay để theo dõi ... */
export function useDeleteFlightRadar() {
  return useMutation({
    mutationKey: ['flight_radar/delete'],
    mutationFn: (id: string) => axios.delete<any>(`/flight_radar/${id}`).then(response => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['flight_radar/fetch_entity_list'] });
      queryClient.invalidateQueries({ queryKey: ['flight_radar/fetch_entity'] });
      queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
    }
  });
}
